<template>
  <div class="list-editable mt-5">
    <ul>
      <li v-for="(i, index) in data" :key="index">
        <contact-input-item class="list-editable-content" :data="i" />
        <vs-button color="danger" type="border" size="small" class="w-full ml-2 mt-6" icon="delete" @click="$emit('delete-item', index)"></vs-button>
      </li>
      <li>
        <vs-button color="primary" type="border" size="small" class="w-full" icon="add" @click="$emit('add-new-item')"></vs-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => { return [] }
    }
  },
  components: {
    ContactInputItem: () => { return import('./ContactInputItem') }
  },
  methods: {
    update(i, $event) {
      console.log(i, $event)
    }
  }
}
</script>

<style lang="scss">
  .list-editable {
    li {
      padding: .2rem 0;
      display: flex;

      .list-editable-content {
        width: calc(100% - 40px);
      }
    }
  }
</style>
